import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export function About() {
    const ref = useRef<HTMLDivElement>(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"]
    });

    const x = useTransform(scrollYProgress, [0, 1], [-50, 50]);

    return (
        <section id="about" ref={ref} className="py-32 px-6 md:px-12 relative overflow-hidden">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">

                {/* Text Content */}
                <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <span className="text-emerald-500 font-mono text-sm tracking-widest mb-4 block">
            // 01. ABOUT ME
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold mb-8 text-white leading-tight">
                        Digital Architect <br />
                        <span className="text-gray-500">Since 2020</span>
                    </h2>
                    <p className="text-gray-300 text-lg leading-relaxed mb-6">
                        I'm a full-stack engineer with a passion for building autonomous systems and immersive web experiences.
                        My approach combines technical precision with creative flair, ensuring every project is not just
                        functional but memorable.
                    </p>
                    <p className="text-gray-400 leading-relaxed">
                        Currently focused on AI-driven automation and scalable cloud architectures.
                        I bridge the gap between complex backend logic and sleek frontend design.
                    </p>
                </motion.div>

                {/* Image Placeholder */}
                <motion.div
                    style={{ x }}
                    className="relative aspect-square md:aspect-[4/5] rounded-2xl overflow-hidden bg-gray-900 border border-white/10"
                >
                    <div className="absolute inset-0 bg-gradient-to-tr from-rose-500/20 to-purple-500/20 mix-blend-overlay z-10" />
                    <img src="/paras-lehana-portrait-visionary-architect-neural-neon.png" alt="Paras Lehana" className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-700" />
                    <div className="absolute bottom-6 left-6 bg-black/60 backdrop-blur-md px-6 py-4 rounded-lg border border-white/10 max-w-[80%]">
                        <p className="text-rose-400 font-mono text-xs mb-1">STATUS UPDATE</p>
                        <p className="text-white font-medium text-sm">Not Available for Hire.<br /><span className="text-gray-400 text-xs">Contact to prove your worth.</span></p>
                    </div>
                </motion.div>

            </div>
        </section>
    );
}
